"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _configProvider = require("../config-provider/configProvider");
var _utils = require("../utils");
var _Circle = _interopRequireDefault(require("./Circle"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CirclePropMapping = {
  small: {
    width: 14,
    strokeWidth: 1
  },
  normal: {
    width: 20,
    strokeWidth: 1.5
  },
  large: {
    width: 28,
    strokeWidth: 2
  }
};
function shouldDelay(loading, delay) {
  return !!loading && !!delay && !Number.isNaN(Number(delay));
}
var defaultGlobalIndicator = '';
var Loading = /*#__PURE__*/function (_PureComponent) {
  function Loading(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Loading);
    _this = _callSuper(this, Loading, [props]);
    var loading = props.loading,
      delay = props.delay;
    _this.state = {
      loading: loading && !shouldDelay(loading, delay),
      prePropLoading: loading,
      prePropDelay: delay
    };
    // 避免在 delay 之前， debounce 切换 loading 带来的多余更新
    _this.debounceTimeout = null;
    _this.delayTimeout = null;
    return _this;
  }
  (0, _inherits2.default)(Loading, _PureComponent);
  return (0, _createClass2.default)(Loading, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        loading = _this$props.loading,
        delay = _this$props.delay;
      if (shouldDelay(loading, delay)) {
        this.delayTimeout = setTimeout(function () {
          return _this2.setState({
            loading: loading
          });
        }, delay);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      var delay = prevProps.delay,
        currentLoading = prevProps.loading;
      var loading = this.props.loading;
      // props.loading不变，不执行任何操作
      if (currentLoading === loading) return;
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      // loading由true转false，200ms后再setState
      if (!loading) {
        this.debounceTimeout = setTimeout(function () {
          return _this3.setState({
            loading: loading
          });
        }, 200);
        if (this.delayTimeout) {
          clearTimeout(this.delayTimeout);
        }
      } else if (loading && delay && !Number.isNaN(Number(delay))) {
        // loading转true且设置了delay，delay后再setState
        if (this.delayTimeout) {
          clearTimeout(this.delayTimeout);
        }
        this.delayTimeout = setTimeout(function () {
          return _this3.setState({
            loading: loading
          });
        }, delay);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.debounceTimeout && clearTimeout(this.debounceTimeout);
      this.delayTimeout && clearTimeout(this.delayTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        style = _this$props2.style,
        size = _this$props2.size,
        message = _this$props2.message,
        children = _this$props2.children,
        indicator = _this$props2.indicator,
        direction = _this$props2.direction,
        fullscreen = _this$props2.fullscreen,
        thickness = _this$props2.thickness;
      var loading = this.state.loading;
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('loading');
      var circleProp = CirclePropMapping[size] || CirclePropMapping.normal;
      var defaultIndicator = defaultGlobalIndicator || /*#__PURE__*/_react.default.createElement(_Circle.default, {
        style: style,
        width: circleProp.width,
        strokeWidth: thickness || circleProp.strokeWidth
      });
      var cls = (0, _classnames3.default)(prefixCls, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-sm"), size === 'small'), "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-show-message"), !!message), "vertical", direction === 'vertical'), "horizontal", direction !== 'vertical'), className, !children && !!className));
      var loadingElement = /*#__PURE__*/_react.default.createElement("div", {
        className: cls,
        style: style
      }, (indicator && (0, _utils.isFunction)(indicator) ? indicator() : indicator) || defaultIndicator, message ? /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames3.default)("".concat(prefixCls, "-message"), size && size !== 'normal' && "".concat(prefixCls, "-message-").concat(size))
      }, (0, _utils.isFunction)(message) ? message() : message) : null);
      if (fullscreen) {
        if (!loading) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: prefixCls
          });
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames3.default)("".concat(prefixCls, "-fullscreen-container"), loading ? "".concat(prefixCls, "-fullscreen-blur") : '')
        }, loading && loadingElement);
      }
      if (children) {
        var containerClassName = (0, _classnames3.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-container"), true), "".concat(prefixCls, "-blur"), loading));
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames3.default)("".concat(prefixCls, "-nested"), "".concat(prefixCls, "-wrapper"), className)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: containerClassName,
          key: "container"
        }, children), loading && loadingElement);
      }
      return loadingElement;
    }
  }], [{
    key: "setDefaultIndicator",
    value: function setDefaultIndicator(indicator) {
      defaultGlobalIndicator = indicator;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prePropDelay = prevState.prePropDelay,
        prePropLoading = prevState.prePropLoading;
      var loading = nextProps.loading,
        delay = nextProps.delay;
      // props.loading或delay不变，不更新state
      if (loading === prePropLoading && delay === prePropDelay) return null;
      // props.loading由false转true且未设置delay时，马上更新state.loading
      if (loading && (!delay || Number.isNaN(Number(delay)))) {
        return {
          loading: loading,
          prePropDelay: delay,
          prePropLoading: loading
        };
      }

      // 其他情况，仅更新preProp
      return {
        prePropDelay: delay,
        prePropLoading: loading
      };
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(Loading, "contextType", _configProvider.ConfigContext);
Loading.contextType = _configProvider.ConfigContext;
Loading.propTypes = {
  children: _propTypes.default.node,
  style: _propTypes.default.shape({}),
  className: _propTypes.default.string,
  loading: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'normal', 'large']),
  direction: _propTypes.default.oneOf(['horizontal', 'vertical']),
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.func]),
  indicator: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  delay: _propTypes.default.number,
  fullscreen: _propTypes.default.bool,
  // 内部组件如Button有修改线宽的需求，不对外暴露
  thickness: _propTypes.default.number
};
Loading.defaultProps = {
  loading: true,
  direction: 'horizontal'
};
var _default = exports.default = Loading;